import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaPlus } from 'react-icons/fa';
import PageTemplate from '../../components/Common/PageTemplate';

const ErasmusCagliari = () => {
  const images = [
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/1.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/2.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/3.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/4.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/5.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/6.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/7.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/8.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/9.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/10.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/11.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/12.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/13.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/14.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/15.jpg",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/matherasmus/16.jpg"
  ];

  const [visibleImages, setVisibleImages] = useState(4);

  const showMoreImages = () => {
    setVisibleImages(images.length);
  };

  return (
    <PageTemplate
      title="Hacettepe Üniversitesi Erasmus Programı: Cagliari"
      subtitle="Uluslararası bilimsel etkinlik başarıyla tamamlandı."
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-lg -mt-16 relative z-10">
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
            <p className="mb-4 text-lg">
              Cagliari Üniversitesi ev sahipliğinde, Erasmus+ Karma Yoğun Program (BIP) kapsamında düzenlenen “Theoretical and Numerical Analysis of Differential Equations and Their Applications” başlıklı uluslararası bilimsel etkinlik başarıyla tamamlandı.
            </p>
            <p className="mb-4 text-lg">
              Bu değerli program, Cagliari Üniversitesi (İtalya), Cádiz Üniversitesi (İspanya) ve Hacettepe Üniversitesi (Türkiye) ortaklığında gerçekleştirildi. Beş gün süren bu etkinlik, İtalya, İspanya ve Türkiye’den gelen öğretim üyeleri ve öğrencilerden oluşan toplam 32 katılımcıyı bir araya getirdi.
            </p>
            <p className="mb-4 text-lg">
              Hacettepe Üniversitesi Matematik Bölümü öğretim üyeleri Doç. Dr. Fatma Gamze Düzgün, Doç. Dr. Berke Kaleboğaz ve Doç. Dr. Eylem Öztürk, derslerde aktif rol almalarının yanı sıra, programın organizasyon komitesinde de görev alarak etkinliğin planlanmasına ve yürütülmesine önemli katkılarda bulundular.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Hacettepe Üniversitesi’ni temsilen programa katılan öğrencilerimiz:</h3>
            <ul className="list-disc list-inside mb-6 text-lg">
              <li>✨ Tolga Topçuoğlu</li>
              <li>✨ Doğan Mete Gümüş</li>
              <li>✨ Cemre Demirtaş</li>
              <li>✨ Nurten Ünlerşen</li>
              <li>✨ Muhammet Safa Aydemir</li>
            </ul>
            <p className="text-lg">
              Yoğun geçen 5 günlük program boyunca öğrencilerimiz, diferansiyel denklemlerin teorik temelleri ve nümerik çözüm yöntemleri üzerine kapsamlı dersler alarak, uluslararası bir akademik ortamda bilgi ve deneyimlerini geliştirme fırsatı buldular. Katılımcı tüm öğrencilerimizi ve hocalarımızı gönülden tebrik ediyoruz.
            </p>
          </div>
        </div>

        <div className="mt-16">
          <h2 className="text-4xl font-extrabold text-center text-gray-800 mb-12 tracking-tight">Etkinlikten Kareler</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {images.slice(0, visibleImages).map((src, index) => (
              <div key={index} className="group relative w-full h-64 overflow-hidden rounded-xl shadow-lg transform transition-all duration-500 ease-in-out hover:shadow-2xl hover:!scale-105">
                <img
                  src={src}
                  alt={`Cagliari Erasmus Ziyareti ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            ))}
          </div>

          {visibleImages < images.length && (
            <div className="text-center mt-12">
              <button
                onClick={showMoreImages}
                className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-semibold rounded-full shadow-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all transform hover:scale-105"
              >
                <FaPlus className="mr-3 -ml-1 h-5 w-5" />
                Daha Fazlasını Gör
              </button>
            </div>
          )}
        </div>
        
        <div className="text-center mt-16">
            <Link 
              to="/haberler" 
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-transform transform hover:scale-105"
            >
              <FaArrowLeft className="mr-3 -ml-1 h-5 w-5" />
              Tüm Haberlere Geri Dön
            </Link>
        </div>

      </div>
    </PageTemplate>
  );
};

export default ErasmusCagliari;
